/**
 * Guía: Mis Reportes.
 *
 * Contenido derivado del capítulo **30** del manual —§0 (un documento que
 * sale de la plataforma)— aplicado a la vista acotada del rol externo.
 *
 * Lo propio de esta pantalla es el alcance: un asesor genera informes de
 * **sus** comercios, no del país.
 */

import type { TourFlow } from '../types';

const MIS_REPORTES_PATH = '/my-reports';

export const c30bMisReportes: TourFlow = {
  id: 'admin.my-reports',
  chapter: '30',
  title: 'Mis reportes',
  summary:
    'Informes de tu cartera: qué entra en ellos y qué revisar antes de generarlos.',
  href: MIS_REPORTES_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Informes de tus comercios, no del país',
      body:
        'Lo que entra en cada documento son las compañías que tienes asignadas. Si una que ' +
        'esperabas no aparece, lo primero es comprobar que esté en tu cartera.',
      route: MIS_REPORTES_PATH,
    },
    {
      id: 'range-first',
      title: 'El rango se revisa antes de generar',
      body:
        'El periodo se recorta en la zona horaria del país y va escrito dentro del ' +
        'documento. Una vez descargado y enviado no se corrige: se emite otro.',
      target: 'admin.myReports.cards',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'leaves-the-platform',
      title: 'Esto sale de la plataforma',
      body:
        'Un informe se adjunta a un correo y se lee meses después sin nadie que lo explique. ' +
        'Conviene decir de qué periodo es y en qué moneda al enviarlo.',
    },
  ],
};
